import { render } from "./notifications.vue?vue&type=template&id=0cd34dfa&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"

import "./notifications.vue?vue&type=style&index=0&id=0cd34dfa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\eoladipo\\Documents\\Windows 10 Mock\\Windows10-mock\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd34dfa"]])

export default __exports__